import axios from "axios";
import axiosInstance from "./service-instance";
import {
    CONTENT_TYPES
} from "constants";
import QueryString from "query-string";
import Endpoint from "constants/endpoint";
import { getAuthToken } from "utilities/auth";
export const UMS_BASE_URL = (function() {
    return process.env.UMS_BASE_URL;
})();
const umsAxiosInstance = axios.create({
    baseURL: UMS_BASE_URL, // Replace 'https://new-base-url.com' with your new base URL
  });

export default {
    retryVerification: identity_id =>
        axiosInstance.put(`/company/identity/${identity_id}/`),
    getSellerList: search =>
        axiosInstance.get(`/invoice/facility/seller-list/?paginate=false&search=${search}`),
    parseGSTIN: gstin =>
        axiosInstance.post("/master/validate/gstin/", {
            gstin
        }),
    getGSTINAddress: gstin =>
        axiosInstance.post("/master/format-address/gstin/", {
            gstin
        }),
    getProducts: () =>
        axiosInstance.get("/master/product/list/", {
            params: {
                paginate: false
            }
        }),
    createCompanyLosProfile: data =>
        axiosInstance.post("/company/create/", data, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    getLendingPartners: () =>
        axiosInstance.get("/master/partner-bank/list/", {
            params: {
                paginate: false
            }
        }),

    getCreditEnhancementBuyerView: (case_id) =>
        axiosInstance.get(`/case/${case_id}/buyer-one-view/`),
    getCreditEnhancementPolicyParameters: case_id =>
        axiosInstance.get(`/case/${case_id}/enhanced-policy/case-wise/`),
    getCreditEnhancementBuyerLimitExposure: (case_id) =>
        axiosInstance.get(`/case/${case_id}/buyer-limit/exposure/`),
    getCreditEnhancementDbView: (case_id) =>
        axiosInstance.get(`/case/${case_id}/db_preview/`),
    getAnchorView: (case_id) =>
        axiosInstance.get(`/case/${case_id}/anchor_view/`),
    getGeoView: (case_id) =>
        axiosInstance.get(`/case/${case_id}/geo_view/`),
    getStateView: (case_id) =>
        axiosInstance.get(`/case/${case_id}/state_view/`),
    getCamEngineAutomation: (case_id) =>
        axiosInstance.get(Endpoint.camEngineAutomation.replace(':case_id', case_id)),    
    getCaseBuyerExposure: (case_id, forceBuild = false) =>
        axiosInstance.get(Endpoint.caseBuyerExposureSanctionView.replace(':case_id', case_id), {
            params: { level: "seller", ...(forceBuild ? { force_build: true } : {}) }
        }),
    getCaseLmsBuyer: (case_id) =>
        axiosInstance.get(Endpoint.caseLmsBuyer.replace(':case_id', case_id)),

    getCompanyProfiles: (type, search, types, is_reporting_anchor = false) =>
        axiosInstance.get("/company/list/", {
            params: {
                // paginate: false,
                page: 1,
                page_size: 20,
                type,
                types,
                search: search && Array.from(new Set(search.split(" "))).join(" "),
                is_reporting_anchor: is_reporting_anchor || undefined
            }
        }),
    // Lighter/faster variant of getCompanyProfiles (id/name/gstin only) for
    // typeahead search where the full profile payload isn't needed.
    getCompanyProfilesLight: (type, search, types, is_reporting_anchor = false) =>
        axiosInstance.get("/company/list/light/", {
            params: {
                page: 1,
                page_size: 20,
                type,
                types,
                search: search && Array.from(new Set(search.split(" "))).join(" "),
                is_reporting_anchor: is_reporting_anchor || undefined
            }
        }),
    // Light variant of getCompanyProfilesFilterList (id/name/gstin only).
    // `type` may be a comma-separated list, eg. "1,2" for Anchor + Distributor.
    getCompanyProfilesFilterListLight: (type, search, industryId) =>
        axiosInstance.get("/company/list/light/", {
            params: {
                page: 1,
                page_size: 20,
                type,
                industry_ids: JSON.stringify(industryId),
                search: search && Array.from(new Set(search.split(" "))).join(" ")
            }
        }),
    getCompanyProfilesFilterList: (type, search, industryId) =>
        axiosInstance.get("/company/list/", {
            params: {
                // paginate: false,
                page: 1,
                page_size: 20,
                type,
                industry_ids: JSON.stringify(industryId),
                search: search && Array.from(new Set(search.split(" "))).join(" ")
            }
        }),
    getCompanyLosProfiles: filters =>
        axiosInstance.get("/company/list/", {
            params: {
                ...filters
            }
        }),
    getChannelProducts: search =>
        axiosInstance.get("/master/channel-product/list/", {
            params: {
                paginate: false,
                search
            }
        }),
    updateAssociate: (company_id, associate) =>
        axiosInstance.put(`/company/${company_id}/associate/`, associate, {
            headers: {
                "Content-Type": CONTENT_TYPES.APPLICATION_JSON
            }
        }),
    updateAddress: (company_id, address) =>
        axiosInstance.put(`/company/${company_id}/address/`, address, {
            headers: {
                "Content-Type": CONTENT_TYPES.APPLICATION_JSON
            }
        }),
    updateBankAccount: (company_id, bankAccount) =>
        axiosInstance.put(
            `/company/${company_id}/bank-accounts/`,
            bankAccount,
            {
                headers: {
                    "Content-Type": CONTENT_TYPES.APPLICATION_JSON
                }
            }
        ),
    updateAssociates: (company_id, associates) =>
        axiosInstance.post(`/company/${company_id}/associates/`, associates, {
            headers: {
                "Content-Type": CONTENT_TYPES.APPLICATION_JSON
            }
        }),
    updateAssociatesCibil: (associate_id, details) =>
        axiosInstance.patch(`/company/associate/${associate_id}/`, details, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    getCibilDocuments: (caseId) =>
        axiosInstance.get(`/company/${caseId}/associates/cibil-document/list/v2/`, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    getCibilParameter: (caseId) =>
        axiosInstance.get(`/case/${caseId}/credit-parameters/`, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    updateCibilParameter: (caseId, data) =>
        axiosInstance.post(`/case/${caseId}/credit-parameters/`, data, {
            headers: {
                "Content-Type": CONTENT_TYPES.APPLICATION_JSON
            }
        }),
    updateAddresses: (company_id, addresses) => {
        return axiosInstance.post(`/company/${company_id}/addresses/`, addresses, {
            headers: {
                "Content-Type": CONTENT_TYPES.APPLICATION_JSON
            }
        });
    },
    updateBankAccounts: (company_id, bankAccounts) =>
        axiosInstance.post(
            `/company/${company_id}/bank-accounts/`,
            bankAccounts,
            {
                headers: {
                    "Content-Type": CONTENT_TYPES.APPLICATION_JSON
                }
            }
        ),
    updateCompanyProfile: (company_id, profile) =>
        axiosInstance.put(`/company/${company_id}/`, profile, {
            headers: {
                "Content-Type": CONTENT_TYPES.APPLICATION_JSON
            }
        }),
    getAssociates: company_id =>
        axiosInstance.get(`/company/${company_id}/associates/`, {
            headers: {
                "Content-Type": CONTENT_TYPES.APPLICATION_JSON
            }
        }),
    getCaseFilterAssociates: (company_id, caseId) =>
        axiosInstance.get(`/company/${company_id}/associates/?case_id=${caseId}`, {
            headers: {
                "Content-Type": CONTENT_TYPES.APPLICATION_JSON
            }
        }),
    getAddresses: company_id =>
        axiosInstance.get(`/company/${company_id}/addresses/`, {
            headers: {
                "Content-Type": CONTENT_TYPES.APPLICATION_JSON
            }
        }),
    getBankAccounts: company_id =>
        axiosInstance.get(`/company/${company_id}/bank-accounts/`, {
            headers: {
                "Content-Type": CONTENT_TYPES.APPLICATION_JSON
            }
        }),
    getCompanyProfile: (company_id, case_id) =>
        axiosInstance.get(`/company/${company_id}/`, {
            params: {
                case_id: case_id,
            },
            headers: {
                "Content-Type": CONTENT_TYPES.APPLICATION_JSON
            }
        }),
    getSupplyChainDetails: case_id =>
        axiosInstance.get("/company/supplychain-financial/", {
            params: {
                case_id
            },
            headers: {
                "Content-Type": CONTENT_TYPES.APPLICATION_JSON
            }
        }),
    getTotalRepaymentDetails: case_id =>
        axiosInstance.get("company/supplychain-financial/repayment/", {
            params: {
                case_id
            },
        }),
    getAnnualTurnOver: case_id =>
        axiosInstance.get(`company/${case_id}/gst-slab-sales-and-questionnaire-sales/`, {
            params: {
                case_id
            },
        }),
    getCompanyCustomereCibilEligibility: (data) =>
        axiosInstance.post("/company/customer-eligibility/", data, {
            headers: {
                "Content-Type": CONTENT_TYPES.APPLICATION_JSON
            }
        }),
    getSupplyChainData: case_id =>
        axiosInstance.get(`/company/supplychain/${case_id}/`, {
            headers: {
                "Content-Type": CONTENT_TYPES.APPLICATION_JSON
            }
        }),
    updateSupplyChainData: (case_id, data) =>
        axiosInstance.post(`/company/supplychain/${case_id}/`, data, {
            headers: {
                "Content-Type": CONTENT_TYPES.APPLICATION_JSON
            }
        }),
    getSupplyChainFinancials: case_id =>
        axiosInstance.get("/company/supplychain-financial/", {
            params: {
                case_id
            },
            headers: {
                "Content-Type": CONTENT_TYPES.APPLICATION_JSON
            }
        }),
    ifscLookup: str =>
        axiosInstance.get(`/master/bank-branch/?ifsc_code=${str}`, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    getSMList: search =>
        axiosInstance.get("/user/sm-hierarchy/", {
            params: {
                search
            }
        }),
    getISPList: search =>
        axiosInstance.get("/user/sm-hierarchy/?role=ISP", {
            params: {
                search
            }
        }),
    updateSMList: (case_id, id) =>
        axiosInstance.put(`case/${case_id}/update-asm/?sales_manager_user_id=${id}`),
    getBuyerExposure: (case_id) =>
        axiosInstance.get(`case/${case_id}/buyer-exposure/`),
    updateISPList: (case_id, id) =>
        axiosInstance.put(`case/${case_id}/update-asm/?inside_sales_personnel_id=${id}`),
    getVPSMList: search =>
        axiosInstance.get("/user/sm-hierarchy/?role=VP Sales", {
            params: {
                search
            }
        }),
    getDRMList: search =>
        axiosInstance.get("/user/sm-hierarchy/", {
            params: {
                search,
                role: "DRM"
            }
        }),

    getUsersList: (role) =>
        axiosInstance.get("/user/sm-hierarchy/", {
            params: {
                role
            }
        }),

    getCorporateRelationshipManager: group =>
        axiosInstance.get("/user/list-user/", {
            params: {
                group
            }
        }),
    locationLookup: ({
        city_id,
        city_name,
        district_id,
        district_name,
        state_id,
        state_name,
        country_id // Default Search Selection in India
    }) =>
        axiosInstance.get("/master/address/master/", {
            params: {
                city_id,
                city_name,
                district_id,
                district_name,
                state_id,
                state_name,
                country_id
            },
            headers: {
                "Content-Type": "application/json"
            }
        }),
    uploadLedger: (caseId, data) =>
        axiosInstance.post(`/company/case/${caseId}/ledger/upload/`, data, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }),
    updateSingleAssociate: (companyId, associates) =>{
        return axiosInstance.post(`/company/associate/${companyId}/create-update/`, associates, {
            headers: {
                "Content-Type": "application/json"
            }
        });},
    updateMultipleAssociate: (companyId, associates) =>
        axiosInstance.put(`/company/${companyId}/associates/`, associates, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    updateSingleBankAccount: (companyId, bankAccount) =>
        axiosInstance.post(`/company/${companyId}/bank-account/create-update/`, bankAccount, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    updateSingleAddress: (companyId, address , case_id) =>
        axiosInstance.post(`/company/${companyId}/address/create-update/`, {...address, case_id}, {
            headers: {
                "Content-Type": "application/json"
            }
        }),
    getProgramAnchor: () =>
        axiosInstance.get("/company/user/list/"),
    getCompanyGstinFillingDetails: (gstin) =>
        axiosInstance.get(`/master/fetch-company-gstin-filing-status/${gstin}/`)
            .then(_ => {
                return Promise.resolve({
                    data: _.data,
                    error: null
                });
            }).catch(error => Promise.resolve({
                data: null,
                error
            })),
    refreshCompanyGstinFillingDetails: (gstin) =>
        axiosInstance.post(`/master/refresh-company-gstin-filing-status/${gstin}/`)
            .then(_ => {
                // if(_.data && _.data.data && _.data.data.EFiledlist && _.data.data.EFiledlist.length) {
                return Promise.resolve({
                    data: _.data,
                    error: null
                });
            })
            .catch(error => Promise.resolve({
                data: null,
                error: error
            })),
    getAssociateVerificationDetails: (companyId) =>
        axiosInstance.get(`/company/${companyId}/identity-validation/list/`, {
            params: {
                identity_type: JSON.stringify([1, 2, 3, 4, 6]),
                paginate: false
            }
        }),
    verifyPanAadhaar: (data) =>
        axiosInstance.post("company/pan-addhar/signzy-verification/", data),

    initiateValidation: (requestId) =>
        axiosInstance.post(`company/${requestId}/initiate/identity-validation/`, {}),

    confirmPhoneEmailValidation: (requestId, data) =>
        axiosInstance.post(`company/${requestId}/confirm/identity-validation/`, data),

    downloadRcuReport: (caseId) =>
        axiosInstance.get(`/company/${caseId}/pdf-generate/verification-status/`, {
            responseType: "arraybuffer"
        }),
    industryTypeList: (search, is_reporting_industry = false) =>
        axiosInstance.get("/master/industry/list/", {
            params: {
                search,
                is_reporting_industry: is_reporting_industry || undefined
            }
        }),
    getUjjivanChecklist: (companyId) =>
        axiosInstance.get(`/${companyId}/ujjivan/corporate-customer/check-list/`),
    postPullBack: (caseId, remarkData) =>
        axiosInstance.post(`/case/${caseId}/case-pull-back/`, remarkData),
    getCaseMovementBtns:(caseId) =>
        axiosInstance.get(`user/${caseId}/movement-permissions/`),
    triggerEnach: (applicant_id, bank_account_id, case_id) =>
        axiosInstance.post("case/case-enach/", {applicant_id, bank_account_id, case_id}),
    getNachRegisteredDate:(caseId)=>
        axiosInstance.get(`case/case-nachstatus/?case_id=${caseId}`),
    getCibilHardPull:(caseId)=>
        axiosInstance.get(`case/customer/cibil/?case_id=${caseId}`),
    triggerCibilHardPull:(typeCibil, body) =>
        axiosInstance.post(`case/${typeCibil}/cibil/`, {...body}),
    camAutomation: (caseId) =>
        axiosInstance.get(`/case/${caseId}/cam-automation/`),
    cibilCommercialParam: (caseId) =>
        axiosInstance.post(`case/${caseId}/cibil-commercial-param/`),
    runCamRuleEngine: (caseId) =>
        axiosInstance.post(`/case/${caseId}/cam-automation/`),
    getLendingPartnersFilter: (bankData) =>
        axiosInstance.get("/master/partner-bank/list/", {
            params: {
                paginate: false,
                bank_code: bankData.toString()
            }
        }),
    getMpaApprovalFilter: (page, page_size, filters) => {
        return  axiosInstance.get(`/company/mpa-approval/anchor-list/?${QueryString.stringify({...filters})}`, {
            params: {
                paginate: true,
                page_size: page_size,
                page: page
            }
        });
    },
    updateBankCaseDetail: (case_id, values) => axiosInstance.put(`/case/${case_id}/change/`, values),
    allDocumentsReviewed:(caseId) =>
        axiosInstance.get(`case/${caseId}/document-reviewed-status/`),
    getCompanyChecklist :(companyId) => axiosInstance.get(`/company/${companyId}/checklist/`),
    addRemoveAssociate : (companyId , associateId) => axiosInstance.delete(`company/${companyId}/add_remove_associate/` , {data : {"associate_id" :associateId}}),
    getCompanyNotes : (action_detail_id) => axiosInstance.get(`workflow/${action_detail_id}/note/list/`),
    createCompanyNote : (payload) => axiosInstance.post("workflow/action-notes/add/" , payload),
    addCustomer: (case_id, case_associate_id, agent_id, caller_id) =>
        axiosInstance.post("case/vkyc/add_customer/", {case_id, case_associate_id, agent_id, caller_id}),
    vkycGetData: (case_id, associateId, is_agent_only) =>{
        return axiosInstance.get(`case/vkyc/vkyc_details/${case_id}/${associateId}/`, { 
            params: {
                get_agent: is_agent_only ? true  : undefined
        }
         });
    },
    vkycSendEmail: (transaction_id) =>
        axiosInstance.post("case/vkyc/notify_user/", {transaction_id}),
    compantCibilCommercialParam: (companyId) =>
        axiosInstance.post(`case/${companyId}/cibil-commercial-param-db/`),

    getComapnyCreditAssessment:(companyId) =>
        axiosInstance.get(`/company/${companyId}/assessment/create-retrieve/`),

    refreshCompanyCreditAssessmentData : (companyId) =>
        axiosInstance.get(`/company/${companyId}/assessment/create-retrieve/`, {
            params: {
                refresh: true
            }
        }),
    updateCompanyCreditAssessment : (companyId, data) =>
        axiosInstance.put(`/company/${companyId}/assessment/create-retrieve/`, data),
    getD2RLimitUtilisation : (companyId) => axiosInstance.get(`/company/${companyId}/d2r_limit_utilisation/`),

    updateD2RLimitUtilisation : (companyId , limit) => axiosInstance.post(`/company/${companyId}/d2r_limit_utilisation/` , { "d2r_limit_by_credit" : limit }),
    companyPostCibilParameter: (companyId) =>
        axiosInstance.post(`case/${companyId}/cibil-commercial-param-db/`, {
            headers: {
                "Content-Type": "application/json"
            }
        }),

    updateCompanyCibilParameter: (companyId, data) =>
        axiosInstance.post(`/case/${companyId}/credit-parameters-db/`, data, {
            headers: {
                "Content-Type": CONTENT_TYPES.APPLICATION_JSON
            }
        }),
    getCompanyCibilParameter: (companyId, data) =>
        axiosInstance.get(`/case/${companyId}/credit-parameters-db/`,  {
            headers: {
                "Content-Type": CONTENT_TYPES.APPLICATION_JSON
            }
        }),
    updateKycVal: (body) => {
        return axiosInstance.post("case/case-kyc-status/",body ,{
            headers :{
                "Content-Type": "multipart/form-data"
            }
        })
    },
    getAdhocCases: (page,page_size, search) => axiosInstance.get(`/workflow/action-detail/adhoc-list/?source=SOUL&page=${page}&page_size=${page_size}&search=${search}`, {
        headers: {
            "Content-Type": "application/json",

        }
    }),
    getAdhocCasesCount: () => axiosInstance.get("/workflow/action-task/adhoc-case-count/?source=SOUL", {
        headers: {
            "Content-Type": "application/json",

        }
    }),
    getAdhocCasesList: (search, ordering, page, pageSize, data_filter) => axiosInstance.get(`/workflow/action-detail/adhoc-list/after-ad-creation/?source=SOUL&search=${search}${ordering !=null?`&ordering=${ordering}`:""}${data_filter!=null ? `&data_filter=${data_filter}` : ""}`, {
        headers: {
            "Content-Type": "application/json",
        },
        params :{
            page ,
            page_size : pageSize
        }
    }),
    getAdhocBulkCasesLimit: (case_ids) => axiosInstance.get(`/workflow/action-detail/adhoc-list/?source=SOUL&case_ids=${case_ids}`, {
        headers: {
            "Content-Type": "application/json",
        }
    }),
    bulkAssignCases: (action_task_ids , remarks , user) => 
        axiosInstance.post("workflow/action-task/bulk-assign/" , {
            action_task_ids: action_task_ids,
            action_remarks : remarks, 
            this_user : user
        }),
    submitAdhocBulkCasesLimit: (body) => axiosInstance.post("/workflow/action-detail/adhoc-case/create/?source=SOUL", body, {
        headers: {
            "Content-Type": "application/json",
        }
    }),
    adhocMovementDataApi: (body) => axiosInstance.post("workflow/action-detail/adhoc/movement/?source=SOUL", body, {
        headers: {
            "Content-Type": "application/json",
        }
    }),
    adhocOpenCaseApi: (case_id, remarks) => axiosInstance.post(`/workflow/action-detail/open/${case_id}/`, {"remarks":remarks} ,{
        headers: {
            "Content-Type": "application/json",
        }
    }),
    getCaseComments: (case_id) => axiosInstance.get(`workflow/${case_id}/note/list/`,{
        headers: {
            "Content-Type": "application/json",
        }
    }),
    updateAdhocParameters: (case_id) => axiosInstance.post(`workflow/action-detail/adhoc/${case_id}/update-json/`,{
        headers: {
            "Content-Type": "application/json",
        }
    }),
    getMpaApprovalParaCriteria: () => axiosInstance.get("company/mpa-approval/parameter-criteria/", {
        headers: {
            "Content-Type": "application/json",
        }
    }),
    getCompanyAssociatesV2:(case_id) => axiosInstance.get(`company/case/${case_id}/associate-and-address-detail/`,{
        headers: {
            "Content-Type": "application/json",
        }
    }),
    getReCreditDetails:(case_id) => axiosInstance.get(`case/${case_id}/re-credit-detail/`,{
        headers: {
            "Content-Type": "application/json",
        }
    }),
    updateCompanyAssociatesV2:(data, case_id) => axiosInstance.post(`company/case/${case_id}/associate-and-address-detail/`, data , {
        headers: {
            "Content-Type": "application/json",
        }
    }),
    getDistrictList:(city) =>  axiosInstance.get(`master/district/list/`,{
        headers: {
            "Content-Type": "application/json",
        },
        params: {
            search :  city
        }
    }),
    getGstinConsent:(gstin) => axiosInstance.get(Endpoint.gstinConsent,{
        params:{
            gstin
        },
        headers: {
            "Content-Type": "application/json",
        }
    }),
    saveMpaDetails:(data, id) =>  axiosInstance.patch(`${Endpoint.mpaDetailBaseURL}/${id}/`, data , {
        headers: {
            "Content-Type": "application/json",
        }
    }),
    addNewProgram : (data) => axiosInstance.post(`${Endpoint.mpaDetailBaseURL}/`, data , {
        headers: {
            "Content-Type": "application/json",
        }
    }),
    getCompanyAllMpa:(company_id) =>  axiosInstance.get(`${Endpoint.mpaDetailBaseURL}/`, {
        headers: {
            "Content-Type": "application/json",
        },
        params :{ 
            company_id,
            source: "soul"
        }
    }),
    deviationMatrixList:(mpa_approval_id) =>  axiosInstance.get(`${Endpoint.deviationMatrixList}`, {
        headers: {
            "Content-Type": "application/json",
        },
        params:{
            mpa_approval_id
        }
    }),
    getMinutesOfMeeting: (companyId) => umsAxiosInstance.get(`${Endpoint.minutesOfMeeting}`,{
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${
                getAuthToken().authToken
            }`
        },
        params:{
            "company_id" : companyId
        }
    }),
    createSlab:(data) =>  axiosInstance.post(`${Endpoint.baseFeeSlab}`, data , {
        headers: {
            "Content-Type": "application/json",
        }
    }),
    deleteSlab:(id) =>  axiosInstance.patch(`${Endpoint.baseFeeSlab}${id}/`, {"is_active" : false}, {
        headers: {
            "Content-Type": "application/json",
        }
    }),
    postMpaDataApi: (companyId,body) => axiosInstance.post(`company/mpa-approval/${companyId}/get-create-update/`,body,{
        headers: {
            "Content-Type": "multipart/form-data"
        },
    }),
    uploadDocument: (companyId, body) => axiosInstance.post(`company/company_documents/${companyId}/`,body,{
        headers: {
            "Content-Type": "multipart/form-data"
        },
    }),
    getMpaDataApi: (companyId) => axiosInstance.get(`company/mpa-approval/${companyId}/get-create-update/`,{
        headers: {
            "Content-Type": "application/json",
        }
    }),
    getDeviationsList : (seller_ids) =>  axiosInstance.get(Endpoint.dbDeviationList,{
        headers: {
            "Content-Type": "application/json",
        },
        params : {
            seller_ids : JSON.stringify(seller_ids)
        }
    }),
    addDbDeviation : (formData) => axiosInstance.post(`company/db-deviation/`,formData,{
        headers: {
            "Content-Type": "multipart/form-data"
        },
    }),
    getEnums : () => axiosInstance.get(Endpoint.getEnums,{
        headers: {
            "Content-Type": "application/json"
        },
    }),
    getGstData : (gstin) => axiosInstance.get(Endpoint.gstinConsent,{
        headers: {
            "Content-Type": "application/json"
        },
        params: {
            gstin
        }
    }),
    getRetailerRisk : (case_id) => axiosInstance.get(Endpoint.retailerPotentialRisk.replace(':case_id', case_id),{
        headers: {
            "Content-Type": "application/json"
        },
    }),
    postRetailerRisk : (case_id, body) => axiosInstance.post(Endpoint.retailerPotentialRisk.replace(':case_id', case_id),body,{
        headers: {
            "Content-Type": "application/json"
        },
    }),
    updateAssessmentReport : (case_id, body) => axiosInstance.post(Endpoint.assessmentReportUpdate.replace(':case_id', case_id),body,{
        headers: {
            "Content-Type": "application/json"
        },
    }),
    companyApplicantAadharMask: (body) => axiosInstance.post(Endpoint.companyDocumentAadharMask, body,{
        headers: {
            "Content-Type": "application/json"
        },
    }),
    trackwizzEntity : (company_id) => axiosInstance.get(Endpoint.trackwizzEntity,{
        headers: {
            "Content-Type": "application/json",
        },
        params: {
            company_id
        }
    }),
    trackwizzContinuous : (caseId) => axiosInstance.get(Endpoint.trackwizzContinousScreening,{
        headers: {
            "Content-Type": "application/json",
        },
        params: {
            case_id: caseId
        }
    }),
    getLedgerMatchData : (case_id) => axiosInstance.get(Endpoint.match_ledger.replace(':case_id', case_id),{
        headers: {
            "Content-Type": "application/json"
        },
    }),
    companyAadharPanLink: (body) => axiosInstance.post(Endpoint.aadharPanLink, body, {
        headers: {
            "Content-Type": "application/json"
        },

    })
};